import { Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useTrackUsage } from '../../hooks/useTrackUsage';
import PathSelectorDialog from '../dialogs/PathSelectorDialog';
import CreateBookDialog from '../idml/CreateBookDialog';
import CreateTextFileDialog from '../textfiles/CreateTextFileDialog';

/**
 * Create text file or Create book from a waiting task: the dialog Files uses, starting from the
 * task, with a folder picker because there's no folder to start in. onCreated gets the new file;
 * the drawer links it. Rendered only while open, so the dialog starts fresh each time.
 */
const CreateForTaskDialog = ({ task, plan, onClose, onCreated }) => {
    useTrackUsage('CreateForTaskDialog', 'dialog', 'tasks');
    const [folder, setFolder] = useState('/');
    const [choosingFolder, setChoosingFolder] = useState(false);
    const CreateDialog = task.contentType === 'BOOK' ? CreateBookDialog : CreateTextFileDialog;

    const folderField = (
        <>
            <Typography variant="overline" component="div">
                Folder in Files
            </Typography>
            <Button size="small" variant="outlined" sx={{ mb: 1 }} onClick={() => setChoosingFolder(true)}>
                {folder}
            </Button>
        </>
    );

    return (
        <>
            <CreateDialog
                open
                onClose={onClose}
                currentPath={folder}
                onFileCreated={onCreated}
                waiting={{ title: task.contentTitle, languages: plan.waitingLanguages, folderField }}
            />
            <PathSelectorDialog
                open={choosingFolder}
                onClose={() => setChoosingFolder(false)}
                onSelect={(path) => {
                    setFolder(path);
                    setChoosingFolder(false);
                }}
                currentPath={folder}
                title="Select Destination Folder"
            />
        </>
    );
};

export default CreateForTaskDialog;
